export const DEVICE_ISSUE_TYPE = {
  gatewayDisconnected: 'gateway_disconnected',
  tabletBatteryLow: 'tablet_battery_low',
  routerWeakSignal: 'router_weak_signal',
} as const;

export type TDeviceIssueType = typeof DEVICE_ISSUE_TYPE[keyof typeof DEVICE_ISSUE_TYPE];

export interface IDeviceIssue {
  issue_type: TDeviceIssueType;
  active: boolean;
  detected_at: string;
}

export type TDeviceIssue = {
  issueType: TDeviceIssueType;
  active: boolean;
};

export interface IDeviceIssueVerifyResponse {
  resolved: boolean;
}

export type TDeviceIssueVerifyOutcome = 'success' | 'failure';
